import { getAuthHeaders, getAxios } from '@/helpers/axios-helper';

import { UserSettings } from '@/stores/user.store';

export const SettingsHelper = {
	async getSettings(justwatchId = '', locale = '', accessToken = ''): Promise<UserSettings> {
		const headers = await getAuthHeaders(accessToken);
		const config = { params: { justwatch_id: justwatchId }, headers };
		const response = await getAxios().get(`${JW_CONFIG.WRITE_URL}/settings/${locale}`, config);
		return response.data;
	},

	async mutateSettingsSet(
		justwatchId = '',
		accessToken = '',
		locale = '',
		currentSettings: UserSettings,
		newSettings: Partial<UserSettings>
	) {
		const headers = await getAuthHeaders(accessToken);
		const config = { params: { justwatch_id: justwatchId }, headers };

		const mutations = [];
		for (const [field, value] of Object.entries(newSettings)) {
			mutations.push({
				field: field,
				unset: (currentSettings as any)[field],
				set: value,
			});
		}

		const result = await getAxios().post(`${JW_CONFIG.WRITE_URL}/settings/${locale}/mutate`, { mutations }, config);
		return result.data;
	},
};
